import styled from '@emotion/styled'
import { Dropdown } from '@hhgtech/hhg-components/components'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

import { assetImagePath } from 'interfaces/constants'
// import { deviceLayout } from 'styles/breakpoint'

export const StyledHealthTools = styled.div`
  .article-bottom-ad {
    margin-bottom: var(--mobile-bottom-height);
    @supports (margin-bottom: env(safe-area-inset-bottom)) {
      margin-bottom: calc(
        env(safe-area-inset-bottom) + var(--mobile-bottom-height)
      );
    }
    ${MediaQueries.mbUp} {
      margin-bottom: 0px;
    }
  }
`

export const StyledThrHealthTool = styled.div`
  .article-bottom-ad {
    margin-bottom: var(--mobile-bottom-height);
    @supports (margin-bottom: env(safe-area-inset-bottom)) {
      margin-bottom: calc(
        env(safe-area-inset-bottom) + var(--mobile-bottom-height)
      );
    }
    ${MediaQueries.mbUp} {
      margin-bottom: 0px;
    }
  }
`
export const StyledMobileSecondArea = styled.div`
  .featured-topics {
    padding: 0;
    & > :first-of-type {
      padding: 0;
    }
  }
`

export const StyledSuggestedArticlesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;

  padding-bottom: 24px;

  .featured-topics {
    padding: 0;
  }

  article[data-size='md'][data-direction='horizontal'] .banner {
    min-width: 100px;
    max-width: 100px;
    height: 100px;
  }
  .bottom-ad {
    margin-top: 20px;
  }

  &.baby-growth {
    padding-bottom: 40px;
  }
`

export const StyledArticleSeeMore = styled.a`
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  &.baby-growth {
    margin-bottom: 0;
  }
`

export const StyledRecordsTimeRange = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  margin-top: 16px;
  padding-left: 28px;

  .input-container {
    width: unset;
    .pickerOverlayWrapper {
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .date-range-picker {
    width: fit-content;
    margin: 0 auto;
    padding: 6px 8px;
    min-width: 230px;
    text-align: center;
    font-size: 14px;

    @media screen and (max-width: 425px) {
      min-width: unset;
      width: 100%;
      text-align: left;
    }
  }
`

export const StyledDropdown = styled(Dropdown)`
  min-width: 154px;
  background-position: right 8px center;

  &#chart-time-type {
    min-width: 112px;
    margin-left: 16px;
  }

  > div {
    padding: 6px 8px;
  }

  > ul {
    z-index: 1000;
  }
`

export const StyledImageIcon = styled.img`
  img& {
    width: 16px;
    height: 16px;
  }
`

export const StyledHealthtoolEmbeddedCareWrapper = styled.div`
  padding: 0 16px;

  .container {
    width: calc(100% + 32px);
    margin: 0 -16px;
  }

  .grid-layout > div:first-of-type {
    margin-left: 8px;
  }
`

export const StyledHealthToolsPageHome = styled.div`
  margin-bottom: 80px;

  .healthtools-header {
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;

    background-repeat: no-repeat;
    background-size: 100%;

    ${MediaQueries.mbDown} {
      background-image: url('${assetImagePath}/bg-tool-sp.svg');
      height: 204px;
      background-position: bottom 18px right 0;
      margin-bottom: 38px;
    }

    ${MediaQueries.mbUp} {
      min-height: 350px;
      background-image: url('${assetImagePath}/bg-tool-pc.svg');
      // background-position: bottom 28px right 0;
      background-size: fit;
    }

    .container {
      display: flex;
      flex-direction: row;
      margin: 52px auto;

      ${MediaQueries.mbDown} {
        padding: 0 16px;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        margin: 0 auto;
      }

      ${MediaQueries.mbUp} {
        max-width: 1170px;
      }
    }

    .headerTitle {
      display: flex;
      width: 60%;
      height: 100%;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;

      ${MediaQueries.mbDown} {
        margin-top: 24px;
        justify-content: flex-start;
        width: 100%;
      }
    }
    .headerLogo {
      display: flex;
      width: 40%;
      align-items: flex-end;

      ${MediaQueries.mbDown} {
        width: 100%;
        justify-content: flex-end;
      }

      img {
        max-width: 325px;
        object-fit: contain;

        ${MediaQueries.mbDown} {
          max-width: 190px;
        }
      }
    }
  }

  .breadcrumbs {
    padding: 8px 0px 16px 0;

    ${MediaQueries.mbUp} {
      padding-top: 20px;
    }
    img {
      max-width: 24px;
    }
  }
  .breadcrumbs {
    padding: 8px 0px 16px 0;

    ${MediaQueries.mbUp} {
      padding-top: 20px;
    }
    img {
      max-width: 24px;
    }
  }

  .healthtools__card {
    display: flex;
    width: 100%;
    min-height: 250px;
    flex-direction: column;
    align-items: center;
    padding: 16px;
    border-radius: ${theme.borderRadius};
    box-shadow: 0px 5px 12px rgba(40, 74, 117, 0.08);
    cursor: pointer;

    &:hover {
      box-shadow: 0px 5px 5px rgba(40, 74, 117, 0.08);
      transition: ease-out 0.3s;
    }

    ${MediaQueries.mbUp} {
      flex-direction: row;
      align-items: flex-start;
      min-height: 150px;
      padding: 21px;

      > div:first-of-type {
        min-width: 75px;
      }

      > div + div {
        margin-left: 8px;
      }

      p {
        & + p {
          margin-top: 4px;
        }
      }
    }
  }

  .healthtools__image {
    flex: 1;
    ${MediaQueries.mbUp} {
      img {
        width: 100%;
        height: auto;
        object-fit: contain;
      }
    }
    ${MediaQueries.mbDown} {
      img {
        width: 100px;
        height: 100px;
        object-fit: contain;
      }
    }
  }

  .healthtools__text-container {
    flex: 2;
  }

  .title {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    /* margin-top: 32px; */
    margin-bottom: 16px;

    .tab {
      display: flex;
      width: 80%;
      align-items: flex-start;
      justify-content: flex-start;
      margin-top: 16px;
      margin-bottom: 8px;
      ${MediaQueries.mbDown} {
        width: 100%;
      }
    }
  }
  .tool-card {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 40px;
  }
  .containerFindTool {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .findYourTool {
    display: flex;
    width: 100%;
    max-width: 768px;
    box-sizing: border-box;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 24px 32px;

    border: 4px solid #e3f2ff;
    margin: 80px 0px;
    border-radius: ${theme.borderRadius};

    ${MediaQueries.mbDown} {
      flex-direction: column;
      gap: 16px;
    }
    .content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;

      ${MediaQueries.mbDown} {
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
      }
    }
    img {
      width: 195.09px;
      height: 202px;
      object-fit: contain;
    }
  }
`
